export class TCActorsData {
	tcId: '';
	userName = '';
	trainingCentreName = '';
	trainingCenterType = '';
	role = 'Training Centre';
	password = 'ekaushal';
	status = '';
	scheme = 'feeBased';
	assignedHA = '';
	firstName = '';
	email = '';
	phone: {
		mobile: number
	} = {
			mobile: null
		};
	HADocument: {
		url: string
	} = {
			url: ''
		};
	spoc: {
		firstName: string,
		email: string,
		mobileNumber: number
	} = {
			firstName: '',
			email: '',
			mobileNumber: null
		};
	address: {
		state: { name: string },
		stateId: number,
		address1: string,
	} = {
			state: { name: '' },
			stateId: null,
			address1: '',
		};
	trainingPartner: {
		id: string,

		name: string,
		userName: string
	} = {
			id: '',
			name: '',
			userName: ''
		};

}
